import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'income',
    loadChildren: () => import('../../sample/sample.module').then(m => m.SampleModule)
  },
  {
    path: 'income-sent',
    loadChildren: () => import('../../income-sent/income-sent.module').then(m => m.IncomeSentModule)
  },
  {
    path: 'income-processed',
    loadChildren: () => import('../../sample/sample.module').then(m => m.SampleModule)
  },
  {
    path: 'movies-data',
    loadChildren: () => import('../../movies-data/movies-data.module').then(m => m.MoviesDataModule)
  },
  {
    path: 'endpoints-list',
    loadChildren: () => import('../../sample/sample.module').then(m => m.SampleModule)
  },
  {
    path: 'cinema-data',
    loadChildren: () => import('../../cinema-data/cinema-data.module').then(m => m.CinemaDataModule)
  },
  {
    path: 'users-data',
    loadChildren: () => import('../../users/users.module').then(m => m.UsersModule)
  },
];
